(() => {
  const selectors = {
    header: '.header',
    categoryHeaderItem: '.js-category-list__header-item',
    categoryListHeader: '.category-list__header',
    categoryListHeaderFixed: '.category-list__header-fixed',
    categoryTitle: '.js-category-title',

    categoryListHeaderFixedActiveClass: 'category-list__header-fixed--active',
    categoryTitleActiveClass: 'category-title--active',
  }
  const categoryHeaderItems = document.querySelectorAll(selectors.categoryHeaderItem);

  const setBodyCSSVariable = () => {
    const header = document.querySelector(selectors.header);
    const headerHeight = header ? header.clientHeight : 0;

    document.body.style.setProperty('--header-height', `${headerHeight}px`);
  }

  const handleIntersection = (entries) => {
    const categorySelect = document.querySelector(selectors.categoryListHeaderFixed);

    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        categorySelect.classList.remove(selectors.categoryListHeaderFixedActiveClass);
      } else {
        categorySelect.classList.add(selectors.categoryListHeaderFixedActiveClass);
      }
    });
  }

  const scrollToCategory = (category) => {
    const contentItem = document.querySelector(`.category-list__content-item[data-category="${category}"]`);
    const additionalOffset = 30;

    if (contentItem) {
      const offsetTop = contentItem.offsetTop - additionalOffset;
      const fixedCategory = document.querySelector(selectors.categoryListHeaderFixed);
      const header = document.querySelector(selectors.header);
      let scrollToPosition = header ? offsetTop - header.clientHeight : offsetTop;

      scrollToPosition = fixedCategory ? scrollToPosition - fixedCategory.clientHeight : scrollToPosition;

      window.scrollTo({
        top: scrollToPosition,
        behavior: 'smooth'
      });
    }
  }

  const highLightCategory = (category) => {
    const categoryTitle = document.querySelectorAll(selectors.categoryTitle);
    const curentTitleArray = document.querySelectorAll(`[data-block-title="${category}"]`);

    categoryTitle.forEach((element) => {
      element.classList.remove(selectors.categoryTitleActiveClass);
    });

    curentTitleArray.forEach((element) => {
      element.classList.add(selectors.categoryTitleActiveClass);
    });
  }

  const handleHash = () => {
    const hash = window.location.hash;
    const cleanHash = hash.substring(1);
    const categoryItem = document.querySelector(`${selectors.categoryHeaderItem}[data-category="${cleanHash}"]`);

    scrollToCategory(cleanHash);

    if (categoryItem ) {
      highLightCategory(categoryItem.dataset.blockTitle);
    }
  };


  if (window.location.hash) {
    handleHash();
  }

  const observer = new IntersectionObserver(handleIntersection, { threshold: 0 });

  observer.observe(document.querySelector(selectors.categoryListHeader));
  setBodyCSSVariable();

  window.addEventListener('resize', setBodyCSSVariable);
  window.addEventListener('scroll', setBodyCSSVariable);

  categoryHeaderItems.forEach((item) => {
    item.addEventListener('click', (event) => {
      event.preventDefault();
      const item = event.currentTarget;
      const category = item.getAttribute('data-category');

      scrollToCategory(category);
      highLightCategory(item.dataset.blockTitle);
    });
  });
})();
